import qs from "qs";
import Axios from "axios";

export class ProjectJuristicFeature {
  constructor(apiUrl, headers) {
    this.juristicFeatureUrl = `${apiUrl}/project/service-features`;
    this.headers = headers;
  }

  async getProjectJuristicFeature(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
      indices: false
    });

    const url = `${this.juristicFeatureUrl}/project${queryString}`;

    const response = await Axios.get(url, {
      headers: this.headers
    });

    return response;
  }

  async getProjectServiceByProjectId(projectId) {
    const url = `${this.juristicFeatureUrl}/${projectId}`;

    const response = await Axios.get(url, {
      headers: this.headers
    });

    return response;
  }

  async updateProjectServiceFeatures(projectId, payload) {
    const url = `${this.juristicFeatureUrl}/${projectId}`;

    const response = await Axios.put(url, payload, {
      headers: this.headers
    });

    return response;
  }
}
